export default __webpack_public_path__ + "static/media/delete_red_icon.68aac07f.svg";